export const DEFAULT_VONEX_ACCOUNT_NUMBER = 61596;
export const NFASBandwidthProfile = [
  { text: "12/1 Mbps", value: "D12_U1_Mbps_TC4_P", disabled: false },
  { text: "25/5 Mbps", value: "D25_U5_Mbps_TC4_P", disabled: false },
  { text: "25/10 Mbps", value: "D25_U10_Mbps_TC4_P", disabled: false },
  { text: "50/20 Mbps", value: "D50_U20_Mbps_TC4_P", disabled: false },
  { text: "50/20 Mbps", value: "D25-50_U5-20_Mbps_TC4_P", disabled: false },
  { text: "100/40 Mbps", value: "D25-100_U5-40_Mbps_TC4_P", disabled: false },
  { text: "100/40 Mbps", value: "D100_U40_Mbps_TC4_P", disabled: false },
  { text: "250/100 Mbps", value: "D250_U100_Mbps_TC4_P", disabled: false },
  {text: "500/200 Mbps",value: "D500_U200_Mbps_TC4_P",disabled: false},
  { text: "500/50 Mbps", value: "Home Fast", disabled: false },
  { text: "750/50 Mbps", value: "Home Superfast", disabled: false },
  { text: "1000/100 Mbps", value: "Home Ultrafast", disabled: false },
  { text: "1000/400 Mbps", value: "D1000_U400_Mbps_TC4_P", disabled: false }, // NFAS gigabit
];
